module.exports = __webpack_public_path__ + "media/img/android-icon-192x192-e4c614199878423a83c00ddf1a2b1716.png";